import { lazy } from 'react';

import type { Policy } from '@cartwhl/common/appletPolicy';

import type { AppletDefinition } from '../../applets';

const AdminUserManagementRoute = lazy(
  () => import('./AdminUserManagementRoute'),
);

const applet = {
  id: 'admin-user-management',
  path: '/admin-user-management',
  paths: ['/admin-user-management'],
  label: 'Admin User Management',
  description: 'Search and manage users, organizations, and service accounts.',
  dashboard: {
    title: 'Admin User Management',
    description:
      'Search and manage users, organizations, and service accounts.',
    order: 90,
  },
  policy: {
    requiresLoggedIn: true,
    requiresAdmin: true,
  } satisfies Policy,
  component: AdminUserManagementRoute,
} satisfies AppletDefinition;

export default applet;
